(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_parent-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const menuItems = document.querySelectorAll('[data-menu-item]');
    if (menuItems.length > 0) {
      const hasActiveItem = Array.from(menuItems).some((item) => item.classList.contains('is-active'));
      //console.log('Has active menu item:', hasActiveItem);
      if (!hasActiveItem) {
        menuItems.forEach((menuItem) => {
          const parentMenu = menuItem.querySelector('[data-parent-menu]');
          parentMenu.classList.remove('opacity-50');
          parentMenu.classList.add('opacity-100');
        }); // You can add logic here for when an active item is found
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
